// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"140":"b98ad387","328":"60ea0ecc","407":"9b7b6a5f","690":"257100a7","814":"dffdafa8"}[chunkId] + ".chunk.css";
};